module.exports = __webpack_public_path__ + "static/img/preview.af3a38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/aliens-vs-predator-microsite/preview.png
// module id = 81
// module chunks = 2